export const addressTypes = {
    DOMESTIC: 'domestic',
    FOREIGN: 'foreign',
    BURIAL_PLACE: 'burial_place',
}
